export default {
	zhuye: 'ホーム',
	qingshururiqi: '日付を入力してください！',
	shengdanshibailianxikefu: '注文が失敗しました。カスタマーサービスにお問い合わせください。',
	jipiao: '航空券',
	tongguo: '合格',
	changlvkehao: 'フリークエントフライヤーナンバー',
	zhongzhuanzai: '乗り継ぎ先',
	zhongzhuanshijian: '乗り継ぎ時間',
	kenengxuyaolvxingzhengjian: '旅行証明書/ビザが必要な場合があります。',
	xinglitongguo: '手荷物通過',
	jiudian: 'ホテル',
	lvyoutaopiao: 'パッケージツアー',
	dumiyue: 'ハネムーン',
	remenyouhui: '人気のセール',
	chakanquanbu: 'すべて表示',
	tebietaopiao: '特別なパッケージ',
	lvyouxinxi: '観光情報',
	gouwuzhongxin: 'ショッピングセンター',
	hangban: 'フライト',
	chengkeziliao: '乗客情報',
	fuyingchanpin: '補助サービス',
	queren: '確認',
	fukuan: '支払い',
	chenggong: '成功',
	xuanzehangban: 'フライトを選択',
	piaojiaguize: '航空券のルールおよび注意事項',
	piaojiaguizes: '航空券のルール',
	feiwang: '行く',
	fanhui: '戻る',
	xiayibu: '次へ',
	gengduoxijie: 'もっと見る',
	yincangxijie: '非表示',
	gengduo: '詳細',
	gengshao: 'より少ない',
	genggaihangban: 'フライトを変更',
	jishangfuwu: '機内サービス',
	boyinqi: 'ボーイング777-300ER',
	yihaohangzhan: '1号ターミナル',
	suoyoufeixingshijian: 'すべての飛行時間は24時間制で表示されます。',
	xinguanfeiyan:
		'異なる国での新型コロナウイルスの最新の発展については、トランジット旅行者は航空券を購入する前にトランジット空港の最新の空港ポリシーと最終目的地の入国制限を確認することをお勧めします。',
	zhongyingbuyizhi:
		'英文版と中文版の目的地および航空会社名に不一致がある場合は、英文版が優先されます。',
	mingzitishi: `正式なファーストネームを英語で入力してください（パスポートに記載されているものが優先されます）。<br>例：あなたのフルネームが「Kwok Fu Hsing」の場合、「Fu Hsing」と入力してください。<br>「Cheung Pak Chi Cecilia」の場合、「Pak Chi Cecilia」と入力してください。<br>中文は入力しないでください。`,
	xingshitishi: '正式な姓を英語で入力してください（パスポートに記載されているものが優先されます）。<br>例：あなたのフルネームが「Kwok Fu Hsing」の場合、「Kwok」と入力してください。<br>「Cheung Pak Chi Cecilia」の場合、「Cheung」と入力してください。<br>は入力しないでください。',
	huzhaohaomatishi: 'この航空会社ではパスポート番号の提供が必要です。',
	yudingchenggong: '予約が成功しました！',
	nindeyudingyishibai: 'あなたの予約は失敗しました。再注文してください。',
	yudingshibai: 'スケジュール失敗',
	yudingcankao: '予約の参考：',
	nindeyudingyiqueren: '予約が確認されました。確認のメールが送信されました',
	ninyekyguanliwodeyuding: '予約を「予約リスト」で管理することもできます。',
	piaojia: 'チケット枚',
	gongxianghangsi: 'シェア航空会社',
	caozuotongguo: '飛行司を執る.',
	fanhuitishixinxi: 'このページを離れると、注文は予約されず、価格が変更される可能性があります。本当に出て行くの?',
	wuxingli: '無料手荷物額なし',
	xingqi1: '月曜日',
	xingqi2: '火曜日',
	xingqi3: '水曜日',
	xingqi4: '木曜日',
	xingqi5: '金曜日',
	xingqi6: '土曜日',
	xingqi0: '日曜日',
	fareRules: {
		tuipiao: "チケットの払い戻し",
		gaiqi: "かわる",
		tuigaishuoming: "修正後の説明",
		qifeiqian: "離陸前",
		qifeihou: "離陸後",
		buketuipiao: "キャンセル不可",
		buketuishui: "税金控除不可",
		bukegaiqi: "変更不可",
		mianfeituipiao: "無料払い戻し",
		mianfeituishui: "無料税金還付",
		mianfeigaiqi: "無料改期",
		tuipiaofei: "キャンセル料",
		tuishuifei: "税金還付費",
		gaiqifei: "かいき料",
		quanchengweishiyong: "全コース未使用",
		quchengyishiyong: "トリップ使用済み、トリップバック済み",
		chufahangban: "出発便",
		huichenghangban: "帰りのフライト"
	}
};
